import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Priorities from "./components/Priorities";
import MeetMark from "./components/MeetMark";
import Navbar from "./components/Navbar";
import Media from "./components/Media";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Endorsements from "./components/Endorsements";

// Priority Pages
import InvestingInPublicSchools from "./components/InvestingInPublicSchools";
import KeepingUsSafe from "./components/KeepingUsSafe";
import SupportingWorkersAndBusinesses from "./components/SupportingWorkersAndBusinesses";
import ProtectingOurEnvironment from "./components/ProtectingOurEnvironment";
import CommittingToTransparencyAndAccountability from "./components/CommittingToTransparencyAndAccountability";
import ElevatingOurVoices from "./components/ElevatingOurVoices";
import BuildingForOurFuture from "./components/BuildingForOurFuture";

const theme = createTheme({
  palette: {
    primary: { main: "#0073e6" },
    secondary: { main: "#e6007e" },
  },
  typography: {
    fontFamily: "Arial, sans-serif",
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/priorities" element={<Priorities />} />
          <Route path="/meetmark" element={<MeetMark />} />
          <Route path="/media" element={<Media />} />
          <Route path="/endorsements" element={<Endorsements />} />
          {/* Priority Pages */}
          <Route path="/investing-in-public-schools" element={<InvestingInPublicSchools />} />
          <Route path="/keeping-us-safe" element={<KeepingUsSafe />} />
          <Route path="/supporting-our-workers-and-businesses" element={<SupportingWorkersAndBusinesses />} />
          <Route path="/protecting-our-environment" element={<ProtectingOurEnvironment />} />
          <Route path="/committing-to-transparency" element={<CommittingToTransparencyAndAccountability />} />
          <Route path="/elevating-our-voices" element={<ElevatingOurVoices />} />
          <Route path="/building-for-our-future" element={<BuildingForOurFuture />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
